import Swal from "sweetalert2";
import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updatePrescriptionType } from "../Redux/Slice/rootSlice";
import { SelectPicker, Stack } from 'rsuite';

const SpermPrescriptionType_PopUp = (props) => {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState("");
  const dispatch = useDispatch();
  const closeUserPopup = (e) => {
    props.setTypePrescriptionPopUp(false);
  };
  const handleDropChanges = (e) => {
    console.log(e.target.value, "mmmm");
    setSelectedType(e.target.value);
  };
  const handleSubmit = (e) => {
            navigate(`/reportcreate/${selectedType}`);
  };  
  return (
    <>
      <div className="adminform">
        <div class="modal-dialog1" role="document">
          <div class="modal-content modelContentChanges">
            <div class="modal-header">
              <h5 class="modal-title">Report</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => closeUserPopup(e)}
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
            <div
              class="modal-body modelBodyChanges"
              style={{ padding: "1rem", width: "520px" }}
            >
              <div className="row">
                <div className="col-12">
                  <p>Select type of report</p>
                </div>
                <div class="col-6 title-dropdown">
                  <select
                    id="type"
                    name="type"
                    value={selectedType}
                    onChange={(e) => handleDropChanges(e)}
                    className="form-select"
                  >
                    <option value="" disabled selected>
                      Select type of report
                    </option>
                      <option value="SemenAnalysis">Semen Analysis</option>
                      <option value="SemenFreezing">Semen Freezing</option>
                    <option value="dfi-report">DFI Report</option>
                    <option value="iui-report">IUI Report</option>
                    {/* <option value="deliveryadmissionform">Delivery Admission Form</option>
                    <option value="deliveryessentials">DeliveryEssentials</option> */}

                    
                  </select>

                  {/* {error && createUserInfo.titles == "" && (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      <span>Required Title</span>
                    </p>
                  )} */}
                </div>
              </div>
            </div>
            <div
              class="modal-footer modelBodyChanges"
              style={{ padding: "1rem", width: "520px" }}
            >
              <button
                onClick={handleSubmit}
                className="submitPrescriptionTypebtn"
                disabled={selectedType !== "" ? false : true}
              >
                Select
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SpermPrescriptionType_PopUp;
